/* unplugin-vue-components disabled */import { render } from "./icon_cart.vue?vue&type=template&id=5581430b&scoped=true"
const script = {}

import "./icon_cart.vue?vue&type=style&index=0&id=5581430b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5581430b"]])

export default __exports__